import { ModuleWithProviders, NgModule } from '@angular/core';
import { WebSocketLocalService } from './e-connect-web-socket-local.service';

@NgModule({
    declarations: [],
    imports: [],
    exports: []
})
export class EConnectWebSocketLocalModule {
    static forRoot(environment: any): ModuleWithProviders<EConnectWebSocketLocalModule> {
        return {
            ngModule: EConnectWebSocketLocalModule,
            providers: [
                WebSocketLocalService,
                { provide: 'env', useValue: environment }]
        };
    }
}
